export default {
  state: {
  },
  mutations: {
    // setProjectData(state, data) {
    //   state.projectData = deepClone(data || {});
    // }
  },
  getters: {
    // 根据uuid获取节点的索引,如果当前点击节点的id是容器的子节点，那么就返回父级节点的索引，加上容器的子节点索引
    // activeElementIndex: state => uuid => {
    //   // 根据ID找索引值
    //   function indexesOf(data, id) {
    //     for (let i = 0; i < data.length; i++) {
    //       const item = data[i];
    //       if (item.uuid === id) return [i];
    //       if (item.childNode && item.childNode.length > 0) {
    //         const childIndexes = indexesOf(item.childNode, id);
    //         if (childIndexes) return [i].concat(childIndexes);
    //       }
    //     }
    //   }
    //   return indexesOf(state.projectData.elements, uuid);
    // }
  },
  actions: {
    // 获取需要删除的节点索引值
    // reqDeleteNodeElement({ getters, commit }, uuid) {
    //   const { activeElementIndex } = getters;
    //   if (!uuid) return "";
    //   const indexData = activeElementIndex(uuid);
    //   commit("deleteNodeElement", indexData);
    // }
  }
};
